const VueLazyloadConfig = {
    filter: {
        webp(listener, options) {
            window.settings.supportsWebP = options.supportWebp;
            if (
                options.supportWebp &&
                typeof listener.src !== 'undefined' &&
                listener.src !== null &&
                typeof listener.el.dataset['webp'] !== 'undefined' &&
                listener.el.dataset['webp'] !== null
            ) {
                listener.src = listener.el.dataset['webp'];
            }
        }
    }
};

export default VueLazyloadConfig;
